import { CalendarMode } from './Calendar.types'

export const modeDaysMap: Record<CalendarMode, number> = {
  [CalendarMode.Day7]: 7,
  [CalendarMode.Day14]: 14,
  [CalendarMode.Day21]: 21,
  [CalendarMode.Week4]: 28,
  [CalendarMode.Week6]: 42,
  [CalendarMode.Week8]: 56,
}

export const ROW_HEIGHTS: Record<CalendarMode, number> = {
  day_7: 36,
  day_14: 32,
  day_21: 28,
  week_4: 24,
  week_6: 20,
  week_8: 16,
}

export const TASK_HEIGHTS: Record<CalendarMode, number> = {
  day_7: 35,
  day_14: 31,
  day_21: 27,
  week_4: 23,
  week_6: 19,
  week_8: 15,
}

export const TASK_FONT_SIZES: Record<CalendarMode, number> = {
  day_7: 12.5,
  day_14: 11.1,
  day_21: 9.72,
  week_4: 8.3,
  week_6: 6.94,
  week_8: 5.56,
}

export const ZONE_FONT_SIZES: Record<CalendarMode, number> = {
  day_7: 14,
  day_14: 12.44,
  day_21: 10.89,
  week_4: 9.33,
  week_6: 7.78,
  week_8: 6.22,
}

export const DEFAULT_MARGIN_IN_DAY = 7 * 4 * 12 * 2
export const DEFAULT_NUMBER_OF_ROW_PER_ZONE = 1
export const DEFAULT_ZONE_WIDTH = 202
export const DEFAULT_TOP_PADDING = 65
export const DEFAULT_WIDTH_FOR_DAY = 50
export const DEFAULT_GAP_FOR_DAY = 1
export const DEFAULT_BORDER_WIDTH_FOR_TASK = 1.5

export const DEFAULT_HEIGHT_FOR_DAY = ROW_HEIGHTS.day_21
export const DEFAULT_TASK_HEIGHT = TASK_HEIGHTS.day_21
export const DEFAULT_TASK_FONT_SIZE = TASK_FONT_SIZES.day_21
export const DEFAULT_ZONE_FONT_SIZE = ZONE_FONT_SIZES.day_21

export const getRowHeight = (mode: CalendarMode): number => {
  return ROW_HEIGHTS[mode] || DEFAULT_HEIGHT_FOR_DAY
}

export const getTaskHeight = (mode: CalendarMode): number => {
  return TASK_HEIGHTS[mode] || DEFAULT_TASK_HEIGHT
}

export const getTaskFontSize = (mode: CalendarMode): number => {
  return TASK_FONT_SIZES[mode] || DEFAULT_TASK_FONT_SIZE
}

export const getZoneFontSize = (mode: CalendarMode): number => {
  return ZONE_FONT_SIZES[mode] || DEFAULT_ZONE_FONT_SIZE
}
